// @flow

import Globalize from './globalize';
import invariant from 'invariant';

export default function changeLocale(locale: string, supported: string[]) {
  invariant(locale, 'New Locale is required.');

  if(supported.includes(locale)) {
    Globalize.locale(locale);
  }
}



// WEBPACK FOOTER //
// ./src/application/globalize/changeLocale.js